import { ownerAvatarColor, ownerInitials, shortDisplayName } from './utils';

type Props = {
    name: string | null | undefined;
    avatarUrl?: string | null;
    showName?: boolean;
    /** Exibe nome + sobrenome (com … se houver mais partes). Default true. */
    compactName?: boolean;
};

export default function DealOwnerCell({ name, avatarUrl, showName = true, compactName = false }: Props) {
    const { short, full: fullName } = shortDisplayName(name);
    const label = compactName ? short : fullName;

    if (!label) {
        return <span className="text-xs text-gray-400 dark:text-zinc-500">—</span>;
    }

    const initials = ownerInitials(fullName || label);
    const bg = ownerAvatarColor(fullName || label);

    const avatar = avatarUrl ? (
        <img
            src={avatarUrl}
            alt={fullName || label}
            title={fullName || label}
            className="h-7 w-7 shrink-0 rounded-full border-2 border-white object-cover shadow-sm ring-1 ring-gray-200 dark:border-zinc-900 dark:ring-zinc-700"
        />
    ) : (
        <span
            title={fullName || label}
            className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-white text-[10px] font-bold text-white shadow-sm ring-1 ring-gray-200 dark:border-zinc-900 dark:ring-zinc-700"
            style={{ backgroundColor: bg }}
        >
            {initials}
        </span>
    );

    if (!showName) {
        return avatar;
    }

    return (
        <div className="flex min-w-0 items-center gap-2">
            {avatar}
            <span className="truncate text-sm font-medium text-gray-700 dark:text-zinc-200" title={fullName || label}>
                {label}
            </span>
        </div>
    );
}
